import { Box, Typography, Button, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Link } from 'react-router-dom';

// ─── Data ──────────────────────────────────────────────────────────────────────
const SITES = [
  {
    name: 'InstaCamGirls',
    url: 'https://instacamgirlslive.com',
    highlight: true,
    badge: '🏆 Best Pick',
    cta: 'Watch Free Now',
    color: '#e91e63',
    features: {
      free: true,
      mobile: true,
      hd: true,
      private: true,
      noCC: true,
      variety: true,
      newModels: true,
      chat: true,
    },
  },
  {
    name: 'Chaturbate',
    url: 'https://instacamgirlslive.com',
    highlight: false,
    badge: null,
    cta: 'Visit Site',
    color: '#ff9800',
    features: {
      free: true,
      mobile: true,
      hd: true,
      private: true,
      noCC: false,
      variety: true,
      newModels: true,
      chat: true,
    },
  },
  {
    name: 'LiveJasmin',
    url: 'https://instacamgirls.cam',
    highlight: false,
    badge: null,
    cta: 'Visit Site',
    color: '#9c27b0',
    features: {
      free: false,
      mobile: true,
      hd: true,
      private: true,
      noCC: false,
      variety: false,
      newModels: false,
      chat: true,
    },
  },
  {
    name: 'OnlyFans',
    url: 'https://instacamgirlslive.com',
    highlight: false,
    badge: null,
    cta: 'Visit Site',
    color: '#00aff0',
    features: {
      free: false,
      mobile: true,
      hd: false,
      private: false,
      noCC: false,
      variety: false,
      newModels: true,
      chat: false,
    },
  },
];

const FEATURE_LABELS = {
  free:      'Free to Watch',
  mobile:    'Mobile Friendly',
  hd:        'HD / 4K Streams',
  private:   'Private Shows',
  noCC:      'No Credit Card Needed',
  variety:   '1000s of Models',
  newModels: 'New Models Daily',
  chat:      'Free Chat',
};

// ─── Feature row ───────────────────────────────────────────────────────────────
const FeatureRow = ({ label, values }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: `200px repeat(${values.length}, 1fr)`,
      alignItems: 'center',
      py: 1.5,
      px: 2,
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      '&:hover': { bgcolor: 'rgba(255,255,255,0.02)' },
    }}
  >
    <Typography sx={{ color: '#ccc', fontSize: 14 }}>{label}</Typography>
    {values.map((v, i) => (
      <Box key={i} sx={{ display: 'flex', justifyContent: 'center' }}>
        {v
          ? <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 22 }} />
          : <CancelIcon sx={{ color: '#555', fontSize: 22 }} />}
      </Box>
    ))}
  </Box>
);

// ─── Page ──────────────────────────────────────────────────────────────────────
const ComparePage = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0d0d0d', color: '#fff', pb: 8 }}>
      {/* Hero */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1a0012 0%, #0d0d0d 60%)',
          pt: { xs: 8, md: 10 },
          pb: 6,
          textAlign: 'center',
          px: 3,
        }}
      >
        <Chip
          label="2024 Comparison"
          size="small"
          sx={{ bgcolor: '#e91e63', color: '#fff', fontWeight: 700, mb: 2, fontSize: 11 }}
        />
        <Typography
          variant="h3"
          sx={{ fontWeight: 800, mb: 2, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          Best Live Cam Sites
          <br />
          <span style={{ color: '#e91e63' }}>— Compared Side by Side</span>
        </Typography>
        <Typography sx={{ color: '#bbb', maxWidth: 540, mx: 'auto', fontSize: 16, lineHeight: 1.7 }}>
          We tested every major platform so you don't have to. Here's the honest breakdown
          of free features, stream quality, and model variety.
        </Typography>
      </Box>

      {/* Comparison table */}
      <Box sx={{ maxWidth: 860, mx: 'auto', px: { xs: 0, md: 2 }, mt: 4 }}>
        {/* Site headers */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: `200px repeat(${SITES.length}, 1fr)`,
            alignItems: 'end',
            px: 2,
            mb: 1,
          }}
        >
          <Box />
          {SITES.map((site) => (
            <Box
              key={site.name}
              sx={{
                textAlign: 'center',
                px: 1,
                py: 2,
                borderRadius: '12px 12px 0 0',
                bgcolor: site.highlight ? 'rgba(233,30,99,0.12)' : 'transparent',
                border: site.highlight ? '1px solid rgba(233,30,99,0.3)' : '1px solid transparent',
                borderBottom: 'none',
                position: 'relative',
              }}
            >
              {site.badge && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: -12,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: '#e91e63',
                    color: '#fff',
                    fontSize: 10,
                    fontWeight: 700,
                    px: 1.5,
                    py: 0.3,
                    borderRadius: 5,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {site.badge}
                </Box>
              )}
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: 13,
                  color: site.highlight ? '#e91e63' : '#fff',
                }}
              >
                {site.name}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Feature rows */}
        <Box
          sx={{
            bgcolor: '#161616',
            borderRadius: 2,
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          {Object.entries(FEATURE_LABELS).map(([key, label]) => (
            <FeatureRow
              key={key}
              label={label}
              values={SITES.map((s) => s.features[key])}
            />
          ))}
        </Box>

        {/* CTA row */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: `200px repeat(${SITES.length}, 1fr)`,
            alignItems: 'center',
            mt: 1,
            px: 2,
            gap: 1,
          }}
        >
          <Box />
          {SITES.map((site) => (
            <Box key={site.name} sx={{ textAlign: 'center', py: 2 }}>
              <Button
                component="a"
                href={site.url}
                target="_blank"
                rel="noopener noreferrer"
                variant={site.highlight ? 'contained' : 'outlined'}
                size="small"
                sx={{
                  bgcolor: site.highlight ? '#e91e63' : 'transparent',
                  borderColor: site.highlight ? '#e91e63' : '#444',
                  color: site.highlight ? '#fff' : '#999',
                  fontWeight: 700,
                  fontSize: 11,
                  textTransform: 'none',
                  borderRadius: 2,
                  px: 2,
                  '&:hover': {
                    bgcolor: site.highlight ? '#c2185b' : 'rgba(255,255,255,0.05)',
                  },
                }}
              >
                {site.cta}
              </Button>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Why section */}
      <Box sx={{ maxWidth: 720, mx: 'auto', px: 3, mt: 8 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 3, textAlign: 'center' }}>
          Why InstaCamGirls Wins
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 2,
          }}
        >
          {[
            { icon: '🆓', title: 'Always Free', desc: 'Browse, chat, and watch without a credit card. No hidden fees, ever.' },
            { icon: '📱', title: 'Any Device', desc: 'Fully optimized for mobile, tablet, and desktop — no app needed.' },
            { icon: '🔴', title: '24/7 Live Streams', desc: 'Thousands of models online around the clock across every category.' },
            { icon: '🔒', title: 'Anonymous Browsing', desc: 'No account required. Watch privately without signing up.' },
          ].map((item) => (
            <Box
              key={item.title}
              sx={{
                bgcolor: '#161616',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: 2,
                p: 3,
              }}
            >
              <Typography sx={{ fontSize: 28, mb: 1 }}>{item.icon}</Typography>
              <Typography sx={{ fontWeight: 700, mb: 0.5 }}>{item.title}</Typography>
              <Typography sx={{ color: '#999', fontSize: 13, lineHeight: 1.6 }}>{item.desc}</Typography>
            </Box>
          ))}
        </Box>

        {/* Final CTA */}
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button
            component="a"
            href="https://instacamgirlslive.com"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            size="large"
            sx={{
              bgcolor: '#e91e63',
              color: '#fff',
              fontWeight: 800,
              fontSize: 16,
              px: 5,
              py: 1.8,
              borderRadius: 3,
              textTransform: 'none',
              '&:hover': { bgcolor: '#c2185b' },
            }}
          >
            Watch Free Live Cams Now →
          </Button>
          <Typography sx={{ color: '#555', fontSize: 12, mt: 1.5 }}>
            No sign-up required. 18+ only.{' '}
            <Link to="/terms" style={{ color: '#555' }}>Terms apply.</Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ComparePage;
